import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { Input } from 'components/layout';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, Grid, Skeleton, Button } from '@mui/material';
import { TableCustom } from 'components/common';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const TemplateNotification = ({
  methods,
  policies,
  fieldData,
  fieldDataConst,
  isLoaded,
  showActions = true
}) => {
  const [t] = useTranslation();
  const theme = useTheme();
  const {
    handleSubmit,
    getValues,
    setValue,
    setError,
    control,
  } = methods;

  const onSubmit = (data) => {
    const { userProject, notificationType } = data;
    const notify = { userProject, notificationType };
    const currentNotifications = getValues(policies.notifications.name);
    const itemFound = currentNotifications.find((n) => JSON.stringify(n) === JSON.stringify(notify));
    if (itemFound) {
      setError(policies.userProject.name, { message: t('common.components.chipList.error') });
      return;
    }
    setValue(policies.notifications.name, [...currentNotifications, notify]);
  };

  const handleDelete = (notify) => {
    const currentNotifications = getValues(policies.notifications.name);
    const newNotifications = currentNotifications.filter(n => JSON.stringify(n) !== JSON.stringify(notify));
    setValue(policies.notifications.name, newNotifications);
  };

  const fields = [
    { policy: policies.userProject, options: fieldData.userProjects, isLoaded },
    { policy: policies.notificationType, options: fieldDataConst.notificationType },
  ];

  const columns = [
    { label: t(policies.userProject.label), key: policies.userProject.name },
    { label: t(policies.notificationType.label), key: policies.notificationType.name },
  ];

  let actions = [
    {
      label: t('templateList.stepper.notification.table.actionDelete'),
      icon: <HighlightOffIcon color='primary'/>,
      handle: handleDelete
    }
  ];

  if (!showActions) {
    actions = []
  }

  return (
    <Box sx={{ overflow: 'hidden' }}>
      { showActions &&
        <Typography variant="h6" sx={{ padding: '8px 0px' }}>
          {t('templateList.stepper.notification.title')}
        </Typography>
      }
      <Grid container spacing={2} alignItems="flex-start">
        { showActions && fields.map((field) => (
          <React.Fragment key={field.policy.id}>
            {!field?.isLoaded ? (
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Input
                  {...field.policy}
                  control={control}
                  options={field.options}
                  sx={{ width: '100%' }}
                />
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Skeleton
                  sx={{ marginBottom: 1 }}
                  variant="text"
                  animation="wave"
                  width="60%"
                />
                <Skeleton height="40px" variant="rounded" animation="wave" />
              </Grid>
            )}
          </React.Fragment>
        ))}
        { showActions &&
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              height: '84px',
            }}
          >
            <Button variant="outlined" onClick={handleSubmit(onSubmit)}>
              {t('templateList.stepper.notification.buttonLabel')}
            </Button>
          </Grid>
        }
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box
            sx={{
              border: `1px solid ${theme.palette.grey[400]}`,
              borderRadius: 1,
              overflow: 'hidden',
            }}
          >
            <Controller
              control={control}
              name={policies.notifications.name}
              id={policies.notifications.id}
              render={({ field: { value } }) => (
                <TableCustom
                  columns={columns}
                  content={value}
                  actions={actions}
                  config={{
                    notResults: {
                      icon: NoAccountsIcon,
                      title:
                        'templateList.stepper.notification.table.title',
                      description:
                        'templateList.stepper.notification.table.description',
                    },
                  }}
                />
              )}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TemplateNotification;
